import { ICallLogRow, latestConnection } from "./CallsDetails";
import { PRIMARY_OBJECTIONS } from "../../../registrant/CallOutcomeDialog";

export const NOT_RECORDED = "Not Recorded";

// How many of the Details tab's calls have each Primary Objection (the registrant's latest connection in the range).
// Every option is listed, plus Not Recorded for calls without one. Shared by the Summary tab and the project report.
export const countPrimaryObjections = (calls: ICallLogRow[], start: Date, end: Date): [string, number][] => {
  const counts = new Map<string, number>([...PRIMARY_OBJECTIONS, NOT_RECORDED].map((objection) => [objection, 0]));
  calls.forEach((call) => {
    const objection = latestConnection(call, start, end)?.primaryObjection || NOT_RECORDED;
    counts.set(objection, (counts.get(objection) || 0) + 1);
  });
  return Array.from(counts.entries());
};
